export const globalStyles = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;600;700;800&display=swap');
  
  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.6; }
  }
  
  @keyframes scaleIn {
    0% {
      transform: scale(0.5);
      opacity: 0;
    }
    50% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
  
  @keyframes move-up {
    0%, 100% { transform: translate(0, 0); }
    50% { transform: translate(0, -20px); }
  }
  
  @keyframes move-down {
    0%, 100% { transform: translate(0, 0); }
    50% { transform: translate(0, 20px); }
  }
  
  @keyframes move-left {
    0%, 100% { transform: translate(0, 0); }
    50% { transform: translate(-20px, 0); }
  }
  
  @keyframes move-right {
    0%, 100% { transform: translate(0, 0); }
    50% { transform: translate(20px, 0); }
  }
  
  @keyframes move-up-right {
    0%, 100% { transform: translate(0, 0); }
    50% { transform: translate(15px, -15px); }
  }
  
  @keyframes move-up-left {
    0%, 100% { transform: translate(0, 0); }
    50% { transform: translate(-15px, -15px); }
  }
  
  @keyframes move-down-right {
    0%, 100% { transform: translate(0, 0); }
    50% { transform: translate(15px, 15px); }
  }
  
  @keyframes move-down-left {
    0%, 100% { transform: translate(0, 0); }
    50% { transform: translate(-15px, 15px); }
  }
  
  * {
    box-sizing: border-box;
  }
  
  button:hover {
    opacity: 0.9;
  }
  
  button:active {
    transform: scale(0.98);
  }
`;

